import {
    TOGGLE_MODAL_ADDITEM,
    TOGGLE_MODAL_BASEUNIT,
    TOGGLE_MODAL_MAINCLIENT,
    TOGGLE_MODAL_SUBCLIENT,
    TOGGLE_MODAL_USERUNIT,
    TOGGLE_MODAL_EXCHANGERATES
} from '../types'

const initialState = {
    addMainClient: false,
    addSubClient: false,
    addUserUnit: false,
    addBaseUnit: false,
    addItem: false,
    exchangeRates: false,
};

const modalsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_MODAL_ADDITEM:
            return {
                ...state,
                addItem: !state.addItem
            };
        case TOGGLE_MODAL_BASEUNIT:
            return {
                ...state,
                addBaseUnit: !state.addBaseUnit
            };
        case TOGGLE_MODAL_MAINCLIENT:
            return {
                ...state,
                addMainClient: !state.addMainClient
            };
        case TOGGLE_MODAL_SUBCLIENT:
            return {
                ...state,
                addSubClient: !state.addSubClient
            };
        case TOGGLE_MODAL_USERUNIT:
            return {
                ...state,
                addUserUnit: !state.addUserUnit
            };
        case TOGGLE_MODAL_EXCHANGERATES:
            return {
                ...state,
                exchangeRates: !state.exchangeRates
            };
        default:
            return state;
    }
};


export default modalsReducer;